import { AspectRatio, Center, useMantineTheme } from '@mantine/core'
import { IconPhoto } from '@tabler/icons-react'

type Props = {
  w?: string | number
  mb?: string
  withoutBorderRadius?: boolean
}

export default function NoImage({ w, mb, withoutBorderRadius }: Props) {
  const theme = useMantineTheme()
  return (
    <AspectRatio ratio={1}>
      <Center
        mx="auto"
        h={w || '100%'}
        w={w || '100%'}
        mb={mb}
        bg={theme.colors.gray[3]}
        style={{ borderRadius: withoutBorderRadius ? '0' : theme.radius.md }}
      >
        <IconPhoto color="white" size={100} />
      </Center>
    </AspectRatio>
  )
}
